import { config } from '@services/config';
import { QuoteMetadataResponse } from '@lio/api-types';
import { OptionQuery } from '@store/PolicySearch';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

import { QuoteMetadataRequestQuery } from '@lio/api-types';
import { buildQueryParamForArray } from '@utils/buildQueryParamForArray';

export const useQuoteMetadata = ({
  customerId,
  statuses,
  types,
}: Omit<QuoteMetadataRequestQuery, 'statuses'> & {
  statuses?: OptionQuery;
}) => {
  const client = useClient();
  const queryParams = new URLSearchParams();
  if (customerId) {
    queryParams.append('customerId', customerId);
  }
  let statusParams = '';
  if (statuses?.queryValue) {
    statusParams = `&statuses=${statuses.queryValue}`;
  }

  if (types) {
    buildQueryParamForArray(queryParams, 'types', types);
  }

  const result = useQuery<QuoteMetadataResponse, Error>({
    queryKey: ['quoteMetadata', { customerId, types }],
    queryFn: () => client.get(`quote/metadata?${queryParams}${statusParams}`).json<QuoteMetadataResponse>(),
    ...config,
  });

  return { ...result, quoteMetadata: result.data };
};
